<template>
    <div>
        <el-dialog
            title="导入"
            :visible.sync="orderImport"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="50%"
            class="carrierConfigUpload"
        >
            <el-row :gutter="5">
                <el-col :span="15">
                    <el-upload
                        class="upload-demo"
                        ref="upload"
                        :on-error="handleError"
                        :before-upload="beforeUpload"
                        :action="ImportConfig.action"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :auto-upload="!ImportConfig.manualUpload"
                        :multiple="ImportConfig.multiple"
                        :show-file-list="ImportConfig.showFileList"
                        :accept="ImportConfig.accept"
                        :on-exceed="handleExceed"
                        :limit="1"
                        :with-credentials="true"
                        :on-success="onSuccess"
                        :file-list="fileList"
                    >
                        <el-button size="small" type="primary"
                            >点击上传</el-button
                        >
                        <span slot="tip" class="el-upload__tip"
                            >上传要求：{{ ImportConfig.fileType }}</span
                        >
                    </el-upload>
                </el-col>
            </el-row>
            <template v-if="errorMsgList.length > 0">
                <ul class="error-text">
                    <li v-for="(msg, index) in errorMsgList" :key="index">
                        {{ msg }}
                    </li>
                </ul>
            </template>
            <div class="error-text" v-if="errorMsgText">{{ errorMsgText }}</div>
            <el-collapse @change="handleChange">
                <el-collapse-item title="模板" name="1">
                    <div
                        class="template_flex"
                        v-for="(item, index) in ImportContent"
                        :key="index"
                    >
                        <div class="template_left">
                            <img src="@/assets/template.png" />
                            <div class="template">
                                <div>{{ item.fileName }}</div>
                                <div>{{ item.fileSize }}</div>
                            </div>
                        </div>
                        <div class="template_float">
                            <i
                                v-if="item.upLoadFlag"
                                class="el-icon-upload2 modelBtn"
                                @click="handleUpload(item)"
                            ></i>
                            <i
                                class="el-icon-download modelBtn"
                                @click="handleDownload(item)"
                            ></i>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveData" :disabled="!file">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import request from '@/utils/http';
export default {
    data () {
        return {
            file: null,
            fileList: [],
            errorMsgList: [],
            errorMsgText: '',
            orderImport: false,
            upLoadInfo: {}, // 上传信息
            uploadInput: {},
            flag: false, // 一个上不了页面的input标签
            successFlag: false
        };
    },
    props: ['ImportConfig', 'ImportContent', 'verifyConfig'],
    created () {
        // 创建导入功能使用的Input标签并添加监听
        this.createInput();
    },
    methods: {
        //  触发弹窗
        orderImportC () {
            this.errorMsgList = [];
            this.errorMsgText = '';
            this.fileList = [];
            this.orderImport = true;
        },
        // 创建导入功能使用的Input标签并添加监听
        createInput () {
            if (!this.flag) {
                return;
            }
            // 创建input标签并添加监听
            this.uploadInput = document.createElement('input');
            this.uploadInput.type = 'file';
        },
        // 上传模板
        handleUpload (item) {
            if (!this.flag) {
                return;
            }
            this.upLoadInfo = item.upLoadInfo;
            this.uploadInput.click();
        },
        beforeUpload (file) {
            if (this.verifyConfig && this.verifyConfig.switch) {
                if (this.verifyConfig.whiteList) {
                    const fileNameSuffix = file.name.substring(file.name.lastIndexOf('.') + 1);
                    if (this.verifyConfig.whiteList.indexOf(fileNameSuffix) === -1) {
                        const msg = this.verifyConfig.whiteList + '';
                        this.$message.warning(`上传文件只能是${msg}格式`);
                        return false;
                    }
                }
                if (this.verifyConfig.fileSize) {
                    const fileSizeVerify = file.size / 1024 < this.verifyConfig.fileSize;
                    if (!fileSizeVerify) {
                        this.$message.warning(`上传文件大小不能超过${this.verifyConfig.fileSize}KB`);
                        return false;
                    }
                }
            };
            this.file = file;
            this.errorMsgList = [];
            this.errorMsgText = '';
            const isText = file.type === 'application/vnd.ms-excel';
            const isTextComputer = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            return (isText | isTextComputer);
        },
        // 下载模板
        handleDownload (item) {
            if (!item.downLoadInfo.url) {
                this.$message.warning('获取模板下载地址失败，刷新页面重试');
                return;
            }
            window.location = item.downLoadInfo.url;
        },
        // 上传失败
        handleError () {
            this.file = null;
            this.$message.warning('上传失败');
        },
        onSuccess (res) {
            if (res && res.code === '0') {
                if (res.data.length) {
                    this.errorMsgList = res.data;
                } else {
                    this.$message.success('导入成功');
                    this.successFlag = true;
                }
            } else {
                this.errorMsgText = res.msg;
            }
        },
        handleExceed (files, fileList) {
            this.$message.warning(`版本暂时不支持同时上传多个文件`);
        },
        saveData () {
            // 确认
            if (this.successFlag) {
                const param = new FormData();
                param.append('file', this.file);
                return request({
                    url: 'api-antms/transport/lsp/transfer/expressImportConfirm',
                    method: 'post',
                    headers: { 'Content-Type': 'multipart/form-data' },
                    data: param
                }).then(res => {
                    if (res && +res.code === 0) {
                        this.$emit('reflashList', true);
                        this.successFlag = false;
                        this.orderImport = false;
                        this.$message({
                            message: `保存成功${res.data.successNum}条，失败${res.data.errorNum}条`,
                            type: 'success',
                            duration: 5000
                        });
                        if (res.data.errorMsg && res.data.errorMsg.length > 0) {
                            const errorText = res.data.errorMsg + '';
                            this.$message({
                                message: errorText,
                                type: 'warning',
                                offset: 80,
                                duration: 5000
                            })
                        }
                    }
                })
                    .catch(() => { });
            } else {
                this.$message.warning('上传文件存在校验不通过的项，需以上校验全部通过才可确定保存');
            }
        },
        handleChange (val) {
            // 导入下拉
        },
        handleRemove (file, fileList) {
            // 行内删除
            if (file) {
                this.file = null;
            }
        },
        handlePreview (file) {
        },
    }
};
</script>

<style lang="less">
.carrierConfigUpload {
    font-size: 18px;
    margin-top: 6vh;

    .upload-demo {
        margin-top: 20px;
    }

    .error-text {
        color: #fff;
        background: #f56c6c;
        line-height: 2;
        padding: 5px 15px;
        border-radius: 5px;
        margin-top: 10px;
        max-height: 150px;
        overflow: auto;
    }

    .el-upload__tip {
        margin-left: 20px;
        color: #999999;
    }

    .el-upload-list {
        padding: 0 10px;
        max-height: 60px;
        overflow-y: auto;
        margin-top: 15px;
    }

    .el-collapse-item__header {
        font-size: 14px;
        background-color: #f2f2f2;
        padding-left: 10px;
        color: #a3a3a3;
        margin-top: 10px;
        height: 40px;
        line-height: 40px;

        .el-icon-document:before {
            content: '\E614';
        }
    }

    .el-collapse {
        border: none;
    }

    .el-collapse-item__content {
        padding-bottom: 10px;
        max-height: 140px;
        overflow-y: auto;
    }

    .el-dialog__body {
        padding: 10px 10px;
    }

    .template_flex {
        display: flex;
        position: relative;
        margin-top: 10px;
        padding: 10px;
        border-bottom: 1px solid #f2f2f2;
    }

    .template_left {
        display: flex;
    }

    .template_left img {
        width: 30px;
        height: 40px;
    }

    .template {
        margin-left: 15px;
        font-size: 12px;
    }

    .template_float {
        font-size: 14px;
        letter-spacing: 10px;
        color: #00bcbf;
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);

        .modelBtn {
            font-size: 18px;
            cursor: pointer;
        }
    }

    .el-collapse-item__wrap {
        border-bottom: none;
    }
}
</style>
